module.exports = __webpack_public_path__ + "img/hockey-sticks.1336e81a.svg";